import { Scissors } from 'phosphor-react';
import React from 'react';
import { translate } from '../Services/translation';

const MAX_COLOR_COUNT = 3;
const MIN_COLOR_COUNT = 2;

const ProductCardImage = ({ product, hideProductTags }) => {
  return (
    <figure className="product__figure">
      <a href={product.url} className="product__image-link">
        {product.images?.length > 0 ? (
          <img
            loading="lazy"
            alt={product.name}
            src={product.images[0]}
          />
        ) : (
          <span className="[ product__image--missing ] [ text-medium ]">
            {translate('product-image.image-missing')}
          </span>
        )}
      </a>
      {!hideProductTags && (
        <div className="[ product-tags ] [ flex-container ]">
          {product.hasConfigurator && (
            <span className="product-tags__tag d-flex align-center">
              <Scissors style={{ marginRight: '4px' }} size={12} />
              {translate('product-image.custom-size')}
            </span>
          )}
          {product.otherProductTags.map((tag) => (
            <span key={product.id + tag} className="product-tags__tag">
              {tag}
            </span>
          ))}
        </div>
      )}
      {product.hasCampaignPrice && (
        <span className="[ sales-tag ] [ lh-1 ]">
          {`-${product.discountPercentage}%`}
        </span>
      )}
      <div className="[ product-relations ]">
        <div className="[ product-relations__color-wrapper ]">
          {product.relatedColors.length >= MIN_COLOR_COUNT &&
            product.relatedColors
              .slice(0, MAX_COLOR_COUNT)
              .map((color, idx) => (
                <span
                  className={`filter-color ${color}`}
                  key={color + idx + product.id}
                ></span>
              ))}
          {product.relatedColors.length > MAX_COLOR_COUNT && (
            <span>+ {product.relatedColors.length - MAX_COLOR_COUNT} </span>
          )}
        </div>
        {product.variants.length > 0 && (
          <span className="[ product-relations__variants ] [ text-xsmall lh-1 color-grey-900 ]">
            {product.relatedColors.length >= MIN_COLOR_COUNT && <span>|</span>}
            {product.variants.length > 1 &&
              translate('products.several-variants')}
          </span>
        )}
      </div>
    </figure>
  );
};

export default ProductCardImage;
